import React, { Component } from "react";
export default function RectangleSvg(props) {
	return (
		<svg 
			xmlns="http://www.w3.org/2000/svg"
			width = {props.width} 
			height = {props.height} 
			viewBox="0 0 10 10"
		>
		<title>{props.title}</title>
	<g
		fill={props.fill} stroke={props.stroke} strokeWidth={props.strokeWidth}
	>
	<rect
		width="10"
       	height="10"
       	x="0"
       	y="0"	   
	/>
  </g>

</svg>
	)}





// WEBPACK FOOTER //
// ./src/assets/img/rectangle.jsx